import React, { useEffect } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import {
  getGenre,
  getCollectionArrangements,
} from '../../../actions/collection';
import { addItemToBreadcrumbsArray, setPageHeadObject } from '../../../actions/app';
import ArrangementsList from '../Common/ArrangementsList.jsx';


const CollectionGenresArrangements = ({ getGenre, getCollectionArrangements,
                                        addItemToBreadcrumbsArray, setPageHeadObject }) => {
  let {slug} = useParams();

  useEffect(() => {
    getGenre(slug).then(response => {
      if (response) {
        addItemToBreadcrumbsArray({title: response.name});
        setPageHeadObject({title: response.name + ' (' + response.count + ')'})
      }
    });
  }, []);

  const loadListFromServer = () => { return getCollectionArrangements(null, slug);}

  return <div>
    <ArrangementsList loadListFromServer={ loadListFromServer } redirectTo={ 'genres' }/>
  </div>
}

CollectionGenresArrangements.propTypes = {
  listCount: PropTypes.number.isRequired,
  getGenre: PropTypes.func.isRequired,
  getGenreArrangements: PropTypes.func.isRequired,
  addItemToBreadcrumbsArray: PropTypes.func.isRequired,
  setPageHeadObject: PropTypes.func.isRequired,
}

export default compose(
  connect(null, {
    getGenre, getCollectionArrangements,
    addItemToBreadcrumbsArray, setPageHeadObject,
  }),
  LoginRequired,
  Page
)(CollectionGenresArrangements);

